import { render } from "./DownloadNode.vue?vue&type=template&id=7ee8b037&scoped=true"
import script from "./DownloadNode.vue?vue&type=script&lang=js"
export * from "./DownloadNode.vue?vue&type=script&lang=js"

import "./DownloadNode.vue?vue&type=style&index=0&id=7ee8b037&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1919945302/src/app.tamildata.org/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ee8b037"]])

export default __exports__